import { isVipsUserType } from "src/utils/userTypes";

export const AUTH_PORTAL_KEY = "authPortal";
export const VIPS_AUTH_PORTAL = "vips";
export const VIPS_LOGIN_PATH = "/vips/login";
export const VIPS_DASHBOARD_PATH = "/dashboard/orders";

export const markVipsAuthPortal = () => {
  localStorage.setItem(AUTH_PORTAL_KEY, VIPS_AUTH_PORTAL);
};

export const clearAuthPortal = () => {
  localStorage.removeItem(AUTH_PORTAL_KEY);
};

export const isVipsAuthPortal = () =>
  localStorage.getItem(AUTH_PORTAL_KEY) === VIPS_AUTH_PORTAL;

export const getLoginPath = () =>
  isVipsAuthPortal() ? VIPS_LOGIN_PATH : "/login";

export const rememberAuthPortal = (userType) => {
  if (isVipsUserType(userType)) {
    markVipsAuthPortal();
    return;
  }
  clearAuthPortal();
};
